import Order from '../entity/order';
import Product from '../entity/product';
import OrderProduct from "../entity/orderProduct";

const START_FETCH = 'confirm#startFetch';
const FINISH_FETCH = 'confirm#finishFetch';
const DISPOSE = 'confirm#dispose';

export type OrderProductType = Map<string, OrderProduct>;

export type FinishType = {
  order: Order;
  orderProducts: OrderProductType;
  products: Product[];
};

export type State = {
  order: Order;
  orderProducts: OrderProductType;
  products: Product[];
  fetches: number;
};

type Action = {
  type:
    | typeof START_FETCH
    | typeof FINISH_FETCH
    | typeof DISPOSE;
  payload?:
    | FinishType
    | null;
};

export const initialState = {
  order: new Order({}),
  orderProducts: new Map(),
  products: [],
  fetches: 0,
};

const confirm = (previousState: State = initialState, { type, payload }: Action): State => {
  if (type === START_FETCH) {
    return {
      ...previousState,
      order: previousState.order,
      fetches: previousState.fetches + 1,
    };
  }

  if (type === FINISH_FETCH) {
    const __payload = payload as FinishType || null;

    if (!__payload) {
      return {
        ...previousState,
        fetches: 0,
      };
    }

    return {
      ...previousState,
      order: __payload.order,
      orderProducts: __payload.orderProducts,
      products: __payload.products,
      fetches: 0,
    };
  }

  if (type === DISPOSE) {
    return {
      ...initialState,
      orderProducts: new Map(),
    };
  }

  return previousState;
};

export const startFetch = (): Action => ({ type: START_FETCH });

export const finishFetch = (payload: FinishType | null): Action => ({
  type: FINISH_FETCH,
  payload,
});

export const dispose = (): Action => ({ type: DISPOSE });

export default confirm;
